import React, { useContext } from "react";
import styles from "./style.module.scss";

import { MainContext } from "../../context/MainContext";

import Image from "../../assets/image/cosmo.png";

function ListItemByID({ listID, comment }) {
  const { markers } = useContext(MainContext);

  const findMarker = markers.find((marker) => marker.id === listID);

  if (findMarker === undefined) return;

  return (
    <div className={styles.list_item}>
      <img
        className={styles.list_item__img}
        src={findMarker.photo}
        alt="images"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = Image;
        }}
      />
      <div className={styles.list_item__box}>
        <p className={styles.list_item__box__title}>{findMarker.name}</p>
        <p className={styles.list_item__box__text}>{findMarker.address}</p>
        {comment && <p className={styles.list_item__box__text}>{comment}</p>}
      </div>
    </div>
  );
}

export default ListItemByID;
